<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" class="text-center">
        <v-card>
          <v-card-title>
            Importar Convenios

            <v-btn text absolute right link small href="/files/ImportarConvenios.csv" target="_blank">
              <v-icon left>download</v-icon> CSV de ejemplo
            </v-btn>
          </v-card-title>

          <v-card-text>
            <file-upload-express
              @fileUploaded="onFileUploaded"
              auto-submit
            />

            <template v-if="!file">
              <h4 class="subtitle-1">Subir archivo .csv</h4>

              <div class="text-left">
                <h3 class="text-left primary--text">Campos obligatorios del csv</h3>
                <br>

                <ul class="text-left">
                  <li><b>CUIL</b> <span class="red--text">*</span></li>
                  <li><b>DNI</b> <span class="red--text">*</span></li>
                  <li><b>Fecha primer pago</b> <span class="red--text">*</span></li>
                  <li><b>Monto Total</b> <span class="red--text">*</span> <span> (En caso de decimales, utilizar punto en lugar de coma. Ej: 10000.50.</span></li>
                  <li><b>Cuotas</b> <span class="red--text">*</span></li>
                </ul>

                <v-alert type="info" dense text class="mt-4 mb-0">
                  El archivo debe contener una fila por DNI. Si el DNI se repite, sólo se procesa la primera aparición.
                </v-alert>
              </div>
            </template>
          </v-card-text>

          <v-card-text v-if="file && !jobId">
            <v-alert type="info">
              Archivo subido exitosamente. Generando tarea de importación en segundo plano.
            </v-alert>
            <v-progress-circular indeterminate />
          </v-card-text>

          <v-card-text v-if="jobId">
            <v-alert type="success">
              Tarea de importación en segundo plano generada con éxito.<br> Id: {{ jobId }}
            </v-alert>
          </v-card-text>

          <v-card-actions v-if="jobId">
            <v-spacer />
            <v-btn
              :to="{name:'JobPage', params:{id: jobId}}"
              color="indigo"
              dark
            >
              Supervisar tarea
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {FileUploadExpress} from '@dracul/media-frontend'
import JobProvider from "@/modules/cobrox/providers/JobProvider";

export default {
  name: "ConvenioImport",
  components: {FileUploadExpress},
  data() {
    return {
      file: null,
      jobId: null,
    }
  },
  methods: {
    onFileUploaded(file) {
      this.file = file
      this.createJob(this.file.id)
    },
    createJob(fileId) {
      JobProvider.importarConvenio(fileId)
        .then((res) => {
          this.jobId = res.data.importarConvenio
        })
    }
  }
}
</script>

<style scoped>

</style>
